
import _ from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import React from "react";
import Table from '../../../../../../../../common/components/table-manager/v1.1/table';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../../../redux/library/selector';
import { plans } from '../../../../../../../../redux/plans/action';
import { selectPlansListItems } from '../../../../../../../../redux/plans/selector';
import { useAppDispatch } from '../../../../../../../../hooks/hooks';

export const PlansListContainer = React.memo(({
  selectedCollection,
  handleSelectedTemplates,
  selectedSms
}: any) => {

  console.log(selectedSms, "selectedShhhms")

  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectPlansListItems)
  const dispatch = useAppDispatch();
  const [localSelectedCollection, setlocalSelectedCollection] = useState<any>(selectedCollection)
  const [localSelectedTemplates, setLocalSelectedTemplates] = useState<any>([])
  const skipNextEffect = useRef(false);
  const currentEntityRef = useRef<any>([]);
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', },
      { field: 'IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' },
      { field: 'StartDateUtc', headerName: 'Start Date', },
      { field: 'EndDateUtc', headerName: 'End Date', },
    ]);
  }

  useEffect(() => {
    setLocalSelectedTemplates(_.uniqBy(selectedCollection?.MediaMappings?.Templates, 'MarketingTemplateId'))
  }, [selectedCollection]);

  const handleSelect = useCallback((selectedRows) => {
    currentEntityRef.current = selectedRows;
    handleSelectedTemplates(selectedRows)

  }, []);

  const listTemplates = async () => {
    await dispatch(plans.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/marketing/campaign-plans/query-by-type`,
      entity: 'plans',
      jsonData: {
        "Records": [
          {  
              "CampaignTypeId": selectedSms?.CampaignTypeId,
            "StartDateUtc": selectedSms?.StartDate,
            "EndDateUtc": selectedSms?.EndDate,
         
          }
        ]
      }
    }))
  }
  useEffect(() => {
    createColumnDefs();

    if (selectedSms?.StartDate && selectedSms?.EndDate) {
      listTemplates();
    }
  }, [selectedSms]);

  return (
    <>
      <Table
        columnData={columnDefs}
        rowData={itemsData?.result?.items}
        enableFilter={true}
        onSelect={handleSelect}
        checkboxConfig={{
          allowMultiSelect: false,
          defaultSelectedIds: [selectedSms?.CampaignPlanId],
          isDisabled: false,
          keyColumn: 'Id',
        }}
        headingName="Plans"
      />

    </>
  )

})

export default PlansListContainer;
